module.exports = {
	"solr": {
		"paths": {
			"API": "http://loheria.man.poznan.pl/"
		},
		"query": {
			"searchPre": "search?",
			"searchPost": "&wt=json"
		},
		"filters": {
			"facet_fileds": [
				"language",
				"data_provider",
				"place_of_publishing"
			],
			"facet_limit": "-1",
			"facet_on": "on",
			"facet_sort_count": "count",
			"facet_mincount": "1",
			"facet_range": "date",
			"facet_date_gap": "1"
		}
	},
	"FBC": {
		"path": "https://fbc.pionier.net.pl",
		"query": {
			"prefix": "/search#",
			"titleFilter": "q=tech_newspaperTitle:",
			"placeFilter": "placeOfPublishing:",
			"fqPrefix": "fq=",
			"dateFilter": "date:",
			"languageFilter": "{!tag=dc_language}",
			"languageFilters": "dc_language:",
			"dataProviderFilter": "{!tag=europeana_dataProvider}",
			"dataProviderFilters": "europeana_dataProvider:",
			"sortBy": "&sort=single_date asc,single_dc_title asc"
		}
	},
	"params": {
		"search": {
			"default": {
				"key": "*:*",
				"param": "",
				"start": 0,
				"pageStart": 1,
				"itemsPerPage": 30,
				"sortOption": "",
				"sortOptionAll": "newspaper_title%20asc"
			}
		}
	},
	"errorsUrl": {
		"error404": "/static/errors/HTTP404.html",
		"error503": "/static/errors/HTTP503.html"
	},
	"brokenImgUrl": "/static/img/owl_text.svg"
};


//////////////////
// WEBPACK FOOTER
// ./src/config/data-prod.json
// module id = 352
// module chunks = 1